export const MobileWebviewEvents = {
  // Navigation Events
  NAVIGATE_TO_OPD: 'navigate_to_opd',
  NEXT_STEP: 'next_step',
  CONTINUE_TO_VDP: 'continue_to_vdp',
  CONTINUE_TO_SRP: 'continue_to_srp',
  EDIT_ORDER: 'edit_order',

  // Fullscreen Events
  ENTER_FULLSCREEN: 'enter_fullscreen',
  LEAVE_FULLSCREEN: 'leave_fullscreen',

  // Plaid/Banking Events
  OPEN_PLAID: 'open_plaid',

  // Trade-In Events
  OPEN_NATIVE_TRADES: 'open_native_trades',

  // Insurance Events
  CONTACT_AGENT: 'contact_agent',
  DISCLAIMER_CLICKED: 'disclaimer_clicked',

  // Protection/Documents Events
  OPEN_CC_BROCHURE: 'open_cc_brochure',
  OPEN_SEBASTIAN: 'open_sebastian',
  OPEN_SUPPORT: 'open_support',
  TOGGLE_CHAT_UI: 'toggle_chat_ui',

  // General Events
  PAGE_READY: 'page_ready',
  WEBVIEW_EVENT: 'webview_event',
  WEBVIEW_BACK_TAPPED: 'webview_back_tapped',
  SAVE_EXIT: 'save_exit',
  SPEED_BUMP: 'speed_bump',
  LINK: 'link',

  // Sebastian Events
  CHAT_CONTEXT_CHANGED: 'page_context_changed'
} as const;
